<template>
  <div >
    <b-container fluid class="md-content">
        <div class="md-header">Plan Optionen Muster</div>
        <b-card>
            <b-row>
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createtemplate')">Muster anlegen</b-button>
                </b-col>
                
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="templates != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="templates" :fields="fields">
                        
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openViewModal(row)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="openEditModal(row)"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
    </b-container>

    <b-modal ref="modal-createtemplate"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Plan Optionen Muster anlegen" @cancel="hideModal('modal-createtemplate')" @ok="createRuleTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Muster Name" label-for="ctfield1">
                    <b-form-input  min="0" id="ctfield1" v-model="ruleTemplate.name" type="text"></b-form-input>
                </b-form-group>

                <b-form-group label="Mitarbeiter Wünsche Berücksichtigung">
                    <b-form-radio-group id="radio-group-1" v-model.number="ruleTemplate.desiredRSetting" name="radio-sub-component1">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.desiredRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.desiredRMin">
                      <b-form-input min="0" :max="ruleTemplate.desiredRMax" id="cer4" v-model.number="ruleTemplate.desiredRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.desiredRSetting === 1 || ruleTemplate.desiredRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.desiredRMax">
                      <b-form-input :min="ruleTemplate.desiredRMin" max="10" id="cer4" v-model.number="ruleTemplate.desiredRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label="Mitarbeiter Abneigungen Berücksichtigung">
                    <b-form-radio-group id="radio-group-2" v-model.number="ruleTemplate.undesiredRSetting" name="radio-sub-component2">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.undesiredRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.undesiredRMin">
                      <b-form-input min="0" :max="ruleTemplate.undesiredRMax" id="cer4" v-model.number="ruleTemplate.undesiredRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.undesiredRSetting === 1 || ruleTemplate.undesiredRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.undesiredRMax">
                      <b-form-input :min="ruleTemplate.undesiredRMin" max="10" id="cer4" v-model.number="ruleTemplate.undesiredRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label="Freie Wochenenden Berücksichtigung">
                    <b-form-radio-group id="radio-group-3" v-model.number="ruleTemplate.weekendRSetting" name="radio-sub-component3">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.weekendRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.weekendRMin">
                      <b-form-input min="0" :max="ruleTemplate.weekendRMax" id="cer4" v-model.number="ruleTemplate.weekendRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.weekendRSetting === 1 || ruleTemplate.weekendRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.weekendRMax">
                      <b-form-input :min="ruleTemplate.weekendRMin" max="10" id="cer4" v-model.number="ruleTemplate.weekendRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label="Freie Wochenends Tage Berücksichtigung">
                    <b-form-radio-group id="radio-group-4" v-model.number="ruleTemplate.weekendDaysRSetting" name="radio-sub-component4">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.weekendDaysRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.weekendDaysRMin">
                      <b-form-input min="0" :max="ruleTemplate.weekendDaysRMax" id="cer4" v-model.number="ruleTemplate.weekendDaysRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.weekendDaysRSetting === 1 || ruleTemplate.weekendDaysRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.weekendDaysRMax">
                      <b-form-input :min="ruleTemplate.weekendDaysRMin" max="10" id="cer4" v-model.number="ruleTemplate.weekendDaysRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label="Skill Berücksichtigung">
                    <b-form-radio-group id="radio-group-5" v-model.number="ruleTemplate.skillRSetting" name="radio-sub-component5">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group label="Fairness Bedingung Berücksichtigung">
                    <b-form-radio-group id="radio-group-6" v-model.number="ruleTemplate.fairnessDefinitionRSetting" name="radio-sub-component6">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.fairnessDefinitionRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.fairnessDefinitionRMin">
                      <b-form-input min="0" :max="ruleTemplate.fairnessDefinitionRMax" id="cer4" v-model.number="ruleTemplate.fairnessDefinitionRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.fairnessDefinitionRSetting === 1 || ruleTemplate.fairnessDefinitionRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.fairnessDefinitionRMax">
                      <b-form-input :min="ruleTemplate.fairnessDefinitionRMin" max="10" id="cer4" v-model.number="ruleTemplate.fairnessDefinitionRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label="Biorhythmus Berücksichtigung">
                    <b-form-radio-group id="radio-group-7" v-model.number="ruleTemplate.bioRSetting" name="radio-sub-component7">
                       <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.bioRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.bioRMin">
                      <b-form-input min="0" :max="ruleTemplate.bioRMax" id="cer4" v-model.number="ruleTemplate.bioRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.bioRSetting === 1 || ruleTemplate.bioRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.bioRMax">
                      <b-form-input :min="ruleTemplate.bioRMin" max="10" id="cer4" v-model.number="ruleTemplate.bioRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mitarbeiter Anzahl limitieren" label-for="ctfield22">
                     <b-form-checkbox id="ctfield22" v-model="ruleTemplate.limitEmployeeCount">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.limitEmployeeCount" label-text-align="left" label-cols="4" label-cols-lg="4" label="Mitarbeiter Anzahl Max." label-for="cer4" :description="ruleTemplate.employeeCountMax+' Mitarbeiter'">
                    <b-form-input min="1" max="200" id="cer4" v-model.number="ruleTemplate.employeeCountMax" type="range"></b-form-input>
                </b-form-group>

                

            </div>
           
            <b-row v-if="templateerror">
                Fehler beim Erstellen des Plan Typ Musters.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-edittemplate"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Plan Optionen Muster bearbeiten" @cancel="hideModal('modal-edittemplate')" @ok="editRuleTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group  label-text-align="left"  label-cols="4" label-cols-lg="4" label="Muster Name" label-for="ctfield1">
                    <b-form-input  min="0" id="ctfield1" v-model="ruleTemplate.name" type="text"></b-form-input>
                </b-form-group>

                <b-form-group label="Mitarbeiter Wünsche Berücksichtigung">
                    <b-form-radio-group id="radio-group-8" v-model.number="ruleTemplate.desiredRSetting" name="radio-sub-component8">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.desiredRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.desiredRMin">
                      <b-form-input min="0" :max="ruleTemplate.desiredRMax" id="cer4" v-model.number="ruleTemplate.desiredRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.desiredRSetting === 1 || ruleTemplate.desiredRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.desiredRMax">
                      <b-form-input :min="ruleTemplate.desiredRMin" max="10" id="cer4" v-model.number="ruleTemplate.desiredRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label="Mitarbeiter Abneigungen Berücksichtigung">
                    <b-form-radio-group id="radio-group-9" v-model.number="ruleTemplate.undesiredRSetting" name="radio-sub-component9">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.undesiredRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.undesiredRMin">
                      <b-form-input min="0" :max="ruleTemplate.undesiredRMax" id="cer4" v-model.number="ruleTemplate.undesiredRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.undesiredRSetting === 1 || ruleTemplate.undesiredRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.undesiredRMax">
                      <b-form-input :min="ruleTemplate.undesiredRMin" max="10" id="cer4" v-model.number="ruleTemplate.undesiredRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label="Freie Wochenenden Berücksichtigung">
                    <b-form-radio-group id="radio-group-10" v-model.number="ruleTemplate.weekendRSetting" name="radio-sub-component10">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.weekendRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.weekendRMin">
                      <b-form-input min="0" :max="ruleTemplate.weekendRMax" id="cer4" v-model.number="ruleTemplate.weekendRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.weekendRSetting === 1 || ruleTemplate.weekendRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.weekendRMax">
                      <b-form-input :min="ruleTemplate.weekendRMin" max="10" id="cer4" v-model.number="ruleTemplate.weekendRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label="Freie Wochenends Tage Berücksichtigung">
                    <b-form-radio-group id="radio-group-11" v-model.number="ruleTemplate.weekendDaysRSetting" name="radio-sub-component12">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.weekendDaysRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.weekendDaysRMin">
                      <b-form-input min="0" :max="ruleTemplate.weekendDaysRMax" id="cer4" v-model.number="ruleTemplate.weekendDaysRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.weekendDaysRSetting === 1 || ruleTemplate.weekendDaysRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.weekendDaysRMax">
                      <b-form-input :min="ruleTemplate.weekendDaysRMin" max="10" id="cer4" v-model.number="ruleTemplate.weekendDaysRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label="Skill Berücksichtigung">
                    <b-form-radio-group id="radio-group-13" v-model.number="ruleTemplate.skillRSetting" name="radio-sub-component13">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group label="Fairness Bedingung Berücksichtigung">
                    <b-form-radio-group id="radio-group-14" v-model.number="ruleTemplate.fairnessDefinitionRSetting" name="radio-sub-component14">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.fairnessDefinitionRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.fairnessDefinitionRMin">
                      <b-form-input min="0" :max="ruleTemplate.fairnessDefinitionRMax" id="cer4" v-model.number="ruleTemplate.fairnessDefinitionRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.fairnessDefinitionRSetting === 1 || ruleTemplate.fairnessDefinitionRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.fairnessDefinitionRMax">
                      <b-form-input :min="ruleTemplate.fairnessDefinitionRMin" max="10" id="cer4" v-model.number="ruleTemplate.fairnessDefinitionRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label="Biorhythmus Berücksichtigung">
                    <b-form-radio-group id="radio-group-15" v-model.number="ruleTemplate.bioRSetting" name="radio-sub-component15">
                        <b-form-radio v-bind:key="0" v-bind:value="0">nicht erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="1" v-bind:value="1">erlaubt</b-form-radio>
                        <b-form-radio v-bind:key="2" v-bind:value="2">unbedingt</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.bioRSetting === 1" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Min." label-for="cer4" :description="'Level '+ruleTemplate.bioRMin">
                      <b-form-input min="0" :max="ruleTemplate.bioRMax" id="cer4" v-model.number="ruleTemplate.bioRMin" type="range"></b-form-input>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.bioRSetting === 1 || ruleTemplate.bioRSetting === 2" label-text-align="left" label-cols="4" label-cols-lg="4" label="Gewichtung Max." label-for="cer4" :description="'Level '+ruleTemplate.bioRMax">
                      <b-form-input :min="ruleTemplate.bioRMin" max="10" id="cer4" v-model.number="ruleTemplate.bioRMax" type="range"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mitarbeiter Anzahl limitieren" label-for="ctfield22">
                     <b-form-checkbox id="ctfield22" v-model="ruleTemplate.limitEmployeeCount">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group v-if="ruleTemplate.limitEmployeeCount" label-text-align="left" label-cols="4" label-cols-lg="4" label="Mitarbeiter Anzahl Max." label-for="cer4" :description="ruleTemplate.employeeCountMax+' Mitarbeiter'">
                    <b-form-input min="1" max="200" id="cer4" v-model.number="ruleTemplate.employeeCountMax" type="range"></b-form-input>
                </b-form-group>
            </div>
           
            <b-row v-if="templateerror">
                Fehler beim Erstellen des Plan Typ Musters.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deletetemplate"  no-close-on-backdrop no-close-on-esc centered title="Plan Optionen Muster löschen" @cancel="hideModal('modal-deletetemplate')" @ok="deleteRuleTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie dieses Plan Optionen Muster löschen wollen?</p>
            </b-row>
            <b-row v-if="templateerror">
                Fehler beim Löschen des Musters.
            </b-row>
        </b-container>
    </b-modal>

   <b-modal ref="modal-viewtemplate"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Plan-Optionen Muster Detail" @cancel="hideModal('modal-viewtemplate')" @ok="hideModal('modal-viewtemplate')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>   
                <b-tab title="Plan-Typ">
                    <div v-if="templateId != undefined && ruleTemplateMap[templateId] != undefined">
                        <b-row>
                            <b-col class="md-2">
                                <b>Name:</b>
                            </b-col>
                            <b-col>
                                {{ruleTemplateMap[templateId].name}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Wünsche.:</b>
                            </b-col>
                            <b-col>
                                {{getLabel(ruleTemplateMap[templateId].desiredRSetting)}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2" >
                                <b>Gewichtung Min.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.desiredR.min}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Gewichtung Max.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.desiredR.max}}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col class="md-2">
                                <b>Abneigungen:</b>
                            </b-col>
                            <b-col>
                                {{getLabel(ruleTemplateMap[templateId].undesiredRSetting)}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Gewichtung Min.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.undesiredR.min}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Gewichtung Max.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.undesiredR.max}}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col class="md-2">
                                <b>Freie Wochenenden:</b>
                            </b-col>
                            <b-col>
                                {{getLabel(ruleTemplateMap[templateId].weekendRSetting)}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Gewichtung Min.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.weekendR.min}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Gewichtung Max.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.weekendR.max}}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col class="md-2">
                                <b>Freie Wochenendstage:</b>
                            </b-col>
                            <b-col>
                                {{getLabel(ruleTemplateMap[templateId].weekendDaysRSetting)}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Gewichtung Min.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.weekendDaysR.min}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Gewichtung Max.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.weekendDaysR.max}}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col class="md-2">
                                <b>Skills:</b>
                            </b-col>
                            <b-col>
                                {{getLabel(ruleTemplateMap[templateId].skillRSetting)}}
                            </b-col>
                        </b-row>
                        
                        <b-row>
                            <b-col class="md-2">
                                <b>Fairness Bedingungen:</b>
                            </b-col>
                            <b-col>
                                {{getLabel(ruleTemplateMap[templateId].fairnessDefinitionRSetting)}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Gewichtung Min.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.fairnessDefinitionR.min}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Gewichtung Max.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.fairnessDefinitionR.max}}
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col class="md-2">
                                <b>Bio Rhythmus:</b>
                            </b-col>
                            <b-col>
                                {{getLabel(ruleTemplateMap[templateId].bioRSetting)}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Gewichtung Min.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.bioR.min}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Gewichtung Max.:</b>
                            </b-col>
                            <b-col>
                                Level {{ruleTemplateMap[templateId].rules.bioR.max}}
                            </b-col>
                        </b-row>
                        <b-row v-if="ruleTemplateMap[templateId].employeeCountMax != null">
                            <b-col class="md-2">
                                <b>Mitarbeiter Max.:</b>
                            </b-col>
                            <b-col>
                                {{ruleTemplateMap[templateId].employeeCountMax}}
                            </b-col>
                        </b-row>
                        
                        
                    </div>
                </b-tab>
                
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    
  </div> 

</template>

<script>
export default {
  name: 'employeerulestemplateoverview',
  data () {
    return {
      templates: [],
      ruleTemplateMap:{},
      fields: [{key:"name", label:"Name", thClass: 'documentsTh', tdClass: 'documentsTd'}, {key:"actions",label: "", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],
      templateId:"",
      currentTemplateRow: undefined,
      ruleTemplate: {
          name: "",
          desiredRSetting: 0,
          desiredRMin: 0,
          desiredRMax: 0,
          undesiredRSetting: 0,
          undesiredRMin: 0,
          undesiredRMax: 0,
          weekendRSetting: 0,
          weekendRMin: 0,
          weekendRMax: 0,
          weekendDaysRSetting: 0,
          weekendDaysRMin: 0,
          weekendDaysRMax: 0,
          skillRSetting: 0,
          fairnessDefinitionRSetting: 0,
          fairnessDefinitionRMin: 0,
          fairnessDefinitionRMax: 0,
          bioRSetting: 0,
          bioRMin: 0,
          bioRMax: 0,
          limitEmployeeCount: false,
          employeeCountMax: null
      },
      templateerror: false,
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;

        this.loadRuleTemplates()
        .then(response => {
            view.updateRuleTemplates(response.data);
        }).catch(function (error) {
            console.log(error)
        })
        
        
    }, 
    getLabel(ruleSetting){
        if(ruleSetting === 1){
            return "erlaubt";
        } else if (ruleSetting === 2){
            return "unbedingt";
        } else {
            return "nicht erlaubt";
        }
    },
    createRuleTemplate: function(evt){
        evt.preventDefault();
        this.templateerror=false;
        let view = this;
        let url = '/api/sec/ruletemplate';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/ruletemplate');
        
        let payload = {
          storeId: this.$store.state.storeId,
          name: this.ruleTemplate.name,
          rules: {}
        }
        if (this.ruleTemplate.desiredRSetting === 1){
            payload.rules.desiredR = {min: this.ruleTemplate.desiredRMin, max: this.ruleTemplate.desiredRMax}
        } else if(this.ruleTemplate.desiredRSetting === 2){
            payload.rules.desiredR = {min: this.ruleTemplate.desiredRMax, max: this.ruleTemplate.desiredRMax}
        } else {
            payload.rules.desiredR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.undesiredRSetting === 1){
            payload.rules.undesiredR = {min: this.ruleTemplate.undesiredRMin, max: this.ruleTemplate.undesiredRMax}
        } else if(this.ruleTemplate.desiredRSetting === 2){
            payload.rules.undesiredR = {min: this.ruleTemplate.undesiredRMax, max: this.ruleTemplate.undesiredRMax}
        } else {
            payload.rules.undesiredR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.weekendRSetting === 1){
            payload.rules.weekendR = {min: this.ruleTemplate.weekendRMin, max: this.ruleTemplate.weekendRMax}
        } else if(this.ruleTemplate.weekendRSetting === 2){
            payload.rules.weekendR = {min: this.ruleTemplate.weekendRMax, max: this.ruleTemplate.weekendRMax}
        } else {
            payload.rules.weekendR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.weekendDaysRSetting === 1){
            payload.rules.weekendDaysR = {min: this.ruleTemplate.weekendDaysRMin, max: this.ruleTemplate.weekendDaysRMax}
        } else if(this.ruleTemplate.weekendDaysRSetting === 2){
            payload.rules.weekendDaysR = {min: this.ruleTemplate.weekendDaysRMax, max: this.ruleTemplate.weekendDaysRMax}
        } else {
            payload.rules.weekendDaysR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.skillRSetting === 1){
            payload.rules.skillR = {min: 0, max: 1}
        } else if(this.ruleTemplate.skillRSetting === 2){
            payload.rules.skillR = {min: 1, max: 1}
        } else {
            payload.rules.skillR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.fairnessDefinitionRSetting === 1){
            payload.rules.fairnessDefinitionR = {min: this.ruleTemplate.fairnessDefinitionRMin, max: this.ruleTemplate.fairnessDefinitionRMax}
        } else if(this.ruleTemplate.weekendRSetting === 2){
            payload.rules.fairnessDefinitionR = {min: this.ruleTemplate.fairnessDefinitionRMax, max: this.ruleTemplate.fairnessDefinitionRMax}
        } else {
            payload.rules.fairnessDefinitionR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.bioRSetting === 1){
            payload.rules.bioR = {min: this.ruleTemplate.bioRMin, max: this.ruleTemplate.bioRMax}
        } else if(this.ruleTemplate.weekendRSetting === 2){
            payload.rules.bioR = {min: this.ruleTemplate.bioRMax, max: this.ruleTemplate.bioRMax}
        } else {
            payload.rules.bioR = {min: 0, max: 0}
        }

        if(this.ruleTemplate.limitEmployeeCount){
            payload.employeeCountMax = this.ruleTemplate.employeeCountMax;
        } else {
            payload.employeeCountMax = null;
        }
        
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            
            view.ruleTemplateMap[response.data.data.id] = response.data.data;
            view.ruleTemplateMap[response.data.data.id].desiredRSetting = view.ruleTemplate.desiredRSetting;
            view.ruleTemplateMap[response.data.data.id].undesiredRSetting = view.ruleTemplate.undesiredRSetting;
            view.ruleTemplateMap[response.data.data.id].weekendRSetting = view.ruleTemplate.weekendRSetting;
            view.ruleTemplateMap[response.data.data.id].weekendDaysRSetting = view.ruleTemplate.weekendDaysRSetting;
            view.ruleTemplateMap[response.data.data.id].skillRSetting = view.ruleTemplate.skillRSetting;
            view.ruleTemplateMap[response.data.data.id].fairnessDefinitionRSetting = view.ruleTemplate.fairnessDefinitionRSetting;
            view.ruleTemplateMap[response.data.data.id].bioRSetting = view.ruleTemplate.bioRSetting;
            let templateItem =  {
                id: response.data.data.id,
                name: response.data.data.name
            }
            view.templates.push(templateItem);
            
            view.hideModal('modal-createtemplate');
 
        }).catch(function (error) {
            view.templateerror=true;
            console.log(error)
        })

    },
    
    openEditModal: function(row){
        this.currentTemplateRow = row;
        this.templateId = row.item.id;
        let templateMapItem = this.ruleTemplateMap[this.templateId];
        this.ruleTemplate = {
          name: templateMapItem.name,
          desiredRSetting: 0,
          desiredRMin: templateMapItem.rules.desiredR.min,
          desiredRMax: templateMapItem.rules.desiredR.max,
          undesiredRSetting: 0,
          undesiredRMin: templateMapItem.rules.undesiredR.min,
          undesiredRMax: templateMapItem.rules.undesiredR.max,
          weekendRSetting: 0,
          weekendRMin: templateMapItem.rules.weekendR.min,
          weekendRMax: templateMapItem.rules.weekendR.max,
          weekendDaysRSetting: 0,
          weekendDaysRMin: templateMapItem.rules.weekendDaysR.min,
          weekendDaysRMax: templateMapItem.rules.weekendDaysR.max,
          skillRSetting: 0,
          fairnessDefinitionRSetting: 0,
          fairnessDefinitionRMin: templateMapItem.rules.fairnessDefinitionR.min,
          fairnessDefinitionRMax: templateMapItem.rules.fairnessDefinitionR.max,
          bioRSetting: 0,
          bioRMin: templateMapItem.rules.bioR.min,
          bioRMax: templateMapItem.rules.bioR.max,
          limitEmployeeCount: false,
          employeeCountMax: templateMapItem.employeeCountMax
        };

        if(this.ruleTemplate.employeeCountMax != null){
            this.ruleTemplate.limitEmployeeCount =  true;
        }

        this.ruleTemplate.desiredRSetting = this.determineRadioSetting(this.ruleTemplate.desiredRMin, this.ruleTemplate.desiredRMax);

        this.ruleTemplate.undesiredRSetting = this.determineRadioSetting(this.ruleTemplate.undesiredRMin, this.ruleTemplate.undesiredRMax);

        this.ruleTemplate.weekendRSetting = this.determineRadioSetting(this.ruleTemplate.weekendRMin, this.ruleTemplate.weekendRMax);

        this.ruleTemplate.weekendDaysRSetting = this.determineRadioSetting(this.ruleTemplate.weekendDaysRMin,this.ruleTemplate.weekendDaysRMax);

        this.ruleTemplate.skillRSetting = this.determineRadioSetting(templateMapItem.rules.skillR.min, templateMapItem.rules.skillR.max);

        this.ruleTemplate.fairnessDefinitionRSetting = this.determineRadioSetting(this.ruleTemplate.fairnessDefinitionRMin, this.ruleTemplate.fairnessDefinitionRMax);

        this.ruleTemplate.bioRSetting = this.determineRadioSetting(this.ruleTemplate.bioRMin, this.ruleTemplate.bioRMax);

        
       

        this.showModal('modal-edittemplate');
    },
    editRuleTemplate: function(evt){
        evt.preventDefault();
        this.templateerror=false;
        let view = this;
        let url = '/api/sec/ruletemplate';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/ruletemplate');
        
        let payload = {
          id: this.templateId,
          updateFields:["name", "rules", "employeeCountMax"],
          name: this.ruleTemplate.name,
          rules: {}
        }

        if (this.ruleTemplate.desiredRSetting === 1){
            payload.rules.desiredR = {min: this.ruleTemplate.desiredRMin, max: this.ruleTemplate.desiredRMax}
        } else if(this.ruleTemplate.desiredRSetting === 2){
            payload.rules.desiredR = {min: this.ruleTemplate.desiredRMax, max: this.ruleTemplate.desiredRMax}
        } else {
            payload.rules.desiredR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.undesiredRSetting === 1){
            payload.rules.undesiredR = {min: this.ruleTemplate.undesiredRMin, max: this.ruleTemplate.undesiredRMax}
        } else if(this.ruleTemplate.desiredRSetting === 2){
            payload.rules.undesiredR = {min: this.ruleTemplate.undesiredRMax, max: this.ruleTemplate.undesiredRMax}
        } else {
            payload.rules.undesiredR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.weekendRSetting === 1){
            payload.rules.weekendR = {min: this.ruleTemplate.weekendRMin, max: this.ruleTemplate.weekendRMax}
        } else if(this.ruleTemplate.weekendRSetting === 2){
            payload.rules.weekendR = {min: this.ruleTemplate.weekendRMax, max: this.ruleTemplate.weekendRMax}
        } else {
            payload.rules.weekendR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.weekendDaysRSetting === 1){
            payload.rules.weekendDaysR = {min: this.ruleTemplate.weekendDaysRMin, max: this.ruleTemplate.weekendDaysRMax}
        } else if(this.ruleTemplate.weekendDaysRSetting === 2){
            payload.rules.weekendDaysR = {min: this.ruleTemplate.weekendDaysRMax, max: this.ruleTemplate.weekendDaysRMax}
        } else {
            payload.rules.weekendDaysR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.skillRSetting === 1){
            payload.rules.skillR = {min: 0, max: 1}
        } else if(this.ruleTemplate.skillRSetting === 2){
            payload.rules.skillR = {min: 1, max: 1}
        } else {
            payload.rules.skillR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.fairnessDefinitionRSetting === 1){
            payload.rules.fairnessDefinitionR = {min: this.ruleTemplate.fairnessDefinitionRMin, max: this.ruleTemplate.fairnessDefinitionRMax}
        } else if(this.ruleTemplate.weekendRSetting === 2){
            payload.rules.fairnessDefinitionR = {min: this.ruleTemplate.fairnessDefinitionRMax, max: this.ruleTemplate.fairnessDefinitionRMax}
        } else {
            payload.rules.fairnessDefinitionR = {min: 0, max: 0}
        }

        if (this.ruleTemplate.bioRSetting === 1){
            payload.rules.bioR = {min: this.ruleTemplate.bioRMin, max: this.ruleTemplate.bioRMax}
        } else if(this.ruleTemplate.weekendRSetting === 2){
            payload.rules.bioR = {min: this.ruleTemplate.bioRMax, max: this.ruleTemplate.bioRMax}
        } else {
            payload.rules.bioR = {min: 0, max: 0}
        }

        if(this.ruleTemplate.limitEmployeeCount){
            payload.employeeCountMax = this.ruleTemplate.employeeCountMax;
        } else {
            payload.employeeCountMax = null;
        }

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.currentTemplateRow.item.name=payload.name;
            
            let templateMapItem = view.ruleTemplateMap[view.templateId];

            if(templateMapItem != undefined){
                for (let property in payload) {
                    if (payload.hasOwnProperty(property) && templateMapItem.hasOwnProperty(property)) {
                        templateMapItem[property] = payload[property];
                    }
                }
            }
          
            templateMapItem.desiredRSetting = view.ruleTemplate.desiredRSetting;
            templateMapItem.undesiredRSetting = view.ruleTemplate.undesiredRSetting;
            templateMapItem.weekendRSetting = view.ruleTemplate.weekendRSetting;
            templateMapItem.weekendDaysRSetting = view.ruleTemplate.weekendDaysRSetting;
            templateMapItem.skillRSetting = view.ruleTemplate.skillRSetting;
            templateMapItem.fairnessDefinitionRSetting = view.ruleTemplate.fairnessDefinitionRSetting;
            templateMapItem.bioRSetting = view.ruleTemplate.bioRSetting;
            
            view.hideModal('modal-edittemplate');
            
            
        }).catch(function (error) {
            view.templateerror=true;
            console.log(error)
        })

    },
    
    openDeleteModal: function(row){
        this.currentTemplateRow = row;
        this.templateId = row.item.id;
        this.showModal('modal-deletetemplate');
    },
    deleteRuleTemplate: function(evt){
        evt.preventDefault();
        this.templateerror=false;
        let view = this;
        let url = '/api/sec/ruletemplate';
        
        url = this.$helpers.appendParam("id", this.templateId, url, '/api/sec/ruletemplate');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetypetemplate');
        
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = view.templates.findIndex(template => template.id === view.templateId)  
            if (~index) {
                view.templates.splice(index, 1);
            } 
            view.deleteRuleTemplateFromMap(view.templateId);
            view.templateId = undefined;
            view.hideModal('modal-deletetemplate');
        }).catch(function (error) {
            view.templateerror=true;
            console.log(error)
        })

    },
    deleteRuleTemplateFromMap(id){
        delete this.ruleTemplateMap[id]
    },
    openViewModal: function(row){
        this.currentTemplateRow = row;
        this.templateId = row.item.id;
        let templateMapItem = this.ruleTemplateMap[this.templateId];
        this.ruleTemplate = {
          name: templateMapItem.name,
          desiredRSetting: 0,
          desiredRMin: templateMapItem.rules.desiredR.min,
          desiredRMax: templateMapItem.rules.desiredR.max,
          undesiredRSetting: 0,
          undesiredRMin: templateMapItem.rules.undesiredR.min,
          undesiredRMax: templateMapItem.rules.undesiredR.max,
          weekendRSetting: 0,
          weekendRMin: templateMapItem.rules.weekendR.min,
          weekendRMax: templateMapItem.rules.weekendR.max,
          weekendDaysRSetting: 0,
          weekendDaysRMin: templateMapItem.rules.weekendDaysR.min,
          weekendDaysRMax: templateMapItem.rules.weekendDaysR.max,
          skillRSetting: 0,
          fairnessDefinitionRSetting: 0,
          fairnessDefinitionRMin: templateMapItem.rules.fairnessDefinitionR.min,
          fairnessDefinitionRMax: templateMapItem.rules.fairnessDefinitionR.max,
          bioRSetting: 0,
          bioRMin: templateMapItem.rules.bioR.min,
          bioRMax: templateMapItem.rules.bioR.max,
          
        };

        this.ruleTemplate.desiredRSetting = this.determineRadioSetting(this.ruleTemplate.desiredRMin, this.ruleTemplate.desiredRMax);

        this.ruleTemplate.undesiredRSetting = this.determineRadioSetting(this.ruleTemplate.undesiredRMin, this.ruleTemplate.undesiredRMax);

        this.ruleTemplate.weekendRSetting = this.determineRadioSetting(this.ruleTemplate.weekendRMin, this.ruleTemplate.weekendRMax);

        this.ruleTemplate.weekendDaysRSetting = this.determineRadioSetting(this.ruleTemplate.weekendDaysRMin,this.ruleTemplate.weekendDaysRMax);

        this.ruleTemplate.skillRSetting = this.determineRadioSetting(templateMapItem.rules.skillR.min, templateMapItem.rules.skillR.max);

        this.ruleTemplate.fairnessDefinitionRSetting = this.determineRadioSetting(this.ruleTemplate.fairnessDefinitionRMin, this.ruleTemplate.fairnessDefinitionRMax);

        this.ruleTemplate.bioRSetting = this.determineRadioSetting(this.ruleTemplate.bioRMin, this.ruleTemplate.bioRMax);

        

        this.showModal('modal-viewtemplate');
    },
    loadRuleTemplates : function() {
      
      let url = '/api/sec/ruletemplate';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/ruletemplate');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    updateRuleTemplates: function(data){
        
        let templateMap = {};
        let templates = [];
        for (let i = 0; i < data.length; i++) {
            let templateMapItem = data[i];
            templateMapItem.desiredRSetting = this.determineRadioSetting(templateMapItem.rules.desiredR.min, templateMapItem.rules.desiredR.max);

            templateMapItem.undesiredRSetting = this.determineRadioSetting(templateMapItem.rules.undesiredR.min, templateMapItem.rules.undesiredR.max);

            templateMapItem.weekendRSetting = this.determineRadioSetting(templateMapItem.rules.weekendR.min, templateMapItem.rules.weekendR.max);

            templateMapItem.weekendDaysRSetting = this.determineRadioSetting(templateMapItem.rules.weekendDaysR.min, templateMapItem.rules.weekendDaysR.max);

            templateMapItem.skillRSetting = this.determineRadioSetting(templateMapItem.rules.skillR.min, templateMapItem.rules.skillR.max);

            templateMapItem.fairnessDefinitionRSetting = this.determineRadioSetting(templateMapItem.rules.fairnessDefinitionR.min, templateMapItem.rules.fairnessDefinitionR.max);

            templateMapItem.bioRSetting = this.determineRadioSetting(templateMapItem.rules.bioR.min, templateMapItem.rules.bioR.max);
           
            templateMap[data[i].id] = templateMapItem;
            let templateItem = {
                id: data[i].id,
                name: data[i].name
            }
            templates.push(templateItem);
        }
        this.ruleTemplateMap = templateMap;
        this.templates = templates;
    },
    determineRadioSetting(min, max){
        if(min == max && max != 0){
               return 2;
        } else if(min > 0 || max > 0){
                return 1;
        } else {
                return 0;
        }
    },
    hideModalWithoutReset (ref) {
        this.templateerror=false;
        this.$refs[ref].hide();
    },
    resetRuleTemplateValues(){
        this.ruleTemplate = {
          name: "",
          desiredRSetting: 0,
          desiredRMin: 0,
          desiredRMax: 0,
          undesiredRSetting: 0,
          undesiredRMin: 0,
          undesiredRMax: 0,
          weekendRSetting: 0,
          weekendRMin: 0,
          weekendRMax: 0,
          weekendDaysRSetting: 0,
          weekendDaysRMin: 0,
          weekendDaysRMax: 0,
          skillRSetting: 0,
          fairnessDefinitionRSetting: 0,
          fairnessDefinitionRMin: 0,
          fairnessDefinitionRMax: 0,
          bioRSetting: 0,
          bioRMin: 0,
          bioRMax: 0,
          limitEmployeeCount: false,
          employeeCountMax: null
          
        }
    },
    
    
    hideModal (ref) {
       
        this.resetRuleTemplateValues();

        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  computed: {
   
  },
  watch: { 
    
  }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>

</style>
